import { freshCsrfToken } from '../lib/fresh_csrf_token.mjs'

// Rendered on signed-in pages while the account is still at the UTC default: posts the browser's
// timezone once so dates show in the user's local time (see AccountTimezones).
export default class extends HTMLElement {
  async connectedCallback () {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone

    if (!timezone || !this.dataset.url || this.posted) return

    this.posted = true

    const { token, signedIn } = await freshCsrfToken()

    if (!signedIn) return

    try {
      await fetch(this.dataset.url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-CSRF-Token': token },
        body: JSON.stringify({ timezone })
      })
    } catch (_error) {
      // Retried on the next page load.
    }
  }
}
